var __webpack_exports__ = {};
/*!********************************************!*\
  !*** ./scripts/components/registration.js ***!
  \********************************************/
class FormRegistration extends HTMLElement {
  constructor() {
    super();
    this.path = this.dataset.path;
    this.form = this.querySelector('form');
    this.formSubmit = this.querySelector('form [type="submit"]');
    this.files = this.querySelectorAll('module-file');
    this.formSubmit.addEventListener('click', this.uploadFile.bind(this));
  }

  makeid() {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < 10; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  async uploadFile(event) {
    event.preventDefault();
    this.classList.add('loading');
    window.scrollTo({
      // eslint-disable-next-line no-undef
      top: 0,
      behavior: 'smooth'
    });
    const allPromises = [];

    Array.from(this.files).map((item) => {
      const file = item.file.files[0];
      const fileName = `${this.form.querySelector("[name='email']").value}-${this.makeid()}.${file.name.split('.').pop()}`;
      allPromises.push(
        fetch('https://content.dropboxapi.com/2/files/upload', {
          method: 'POST',
          headers: {
            Authorization: 'Bearer _31Tv0QaD-kAAAAAAAAAAVALEou84IGWDX02FSz1bv0VjvH6nfKWd0VE1a-rUVPO',
            'Dropbox-API-Arg': `{"path": "${this.path}${fileName}","mode": "add","autorename": true,"mute": false}`,
            'Content-Type': 'application/octet-stream'
          },
          body: file
        }).then((response) => response.json())
      );
    });

    Promise.all(allPromises).then((data) => {
      data.map((item, index) => {
        if (item?.path_display) this.files[index].fileName.value = item.path_display;
      });
      this.form.requestSubmit();
      this.classList.remove('loading');
    });
  }
}

customElements.get('form-registration') || customElements.define('form-registration', FormRegistration);

